module.exports = __webpack_public_path__ + "media/beep.7f89f0da.wav";